var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isForm()
    ? _c(
        "section",
        {
          key: _vm.componentKey,
          class: { "lexon-view-container": !_vm.showSpinnerLayer },
        },
        [_c("router-view")],
        1
      )
    : _c("router-view", { key: _vm.componentKey })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }